import { Component } from "../../components/base/Component";
import { ICfa } from "../../models/ICfa";
import { ComponentFactory } from "../../services/ComponentFactory";
import { AddressAutocompleteService } from "./AddressAutocompleteService";
import { inputDebounce } from "../../util/InputDebounce";
import { IAutoCompleteResponseTransformed } from "./IAutoCompleteResponseTransformed";
export class AddressAutocomplete extends Component {
	private readonly autoCompleteService;
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
		const dxeEndpoint = this.getDXEAPIEndpoint();
		const bearerTokenEndpoint = this.getBearerTokenEndpoint();
		this.autoCompleteService = new AddressAutocompleteService(
			bearerTokenEndpoint,
			dxeEndpoint
		);

		this.handleAutocomplete();
	}

	handleAutocomplete(): void {
		const delay = 500;
		this._element.addEventListener(
			"input",
			inputDebounce(async e => {
				const target = e.target as HTMLInputElement;
				if (target.value) {
					await this.loadAutocompleteResults(target.value);
				}
			}, delay)
		);
	}

	async loadAutocompleteResults(value: string): Promise<void> {
		const suggestions = await this.autoCompleteService.getAddressSuggestions(
			value
		);
		$(this._element)
			.autocomplete({
				classes: {
					"ui-autocomplete": "signature-drop-autocomplete-menu"
				},
				select: (event, ui) => {
					// tslint:disable-next-line: no-unsafe-any
					this._element.setAttribute("value", ui.item.placeId);
				},
				source: suggestions
			})
			.autocomplete("instance")._renderItem = (
			ul: HTMLElement,
			item: IAutoCompleteResponseTransformed
		) => {
			return $("<li>")
				.append(`<div>${item.label}<br>${item.desc}</div>`)
				.appendTo(ul);
		};
		$(this._element).autocomplete(
			"option",
			"classes.ui-autocomplete",
			"signature-drop-autocomplete-menu"
		);
	}

	getBearerTokenEndpoint(): string {
		if (!this._element.dataset.bearerEndpoint) {
			throw new Error(
				"'data-bearer-endpoint' value not provided on #CustomAddress input field."
			);
		}

		return this._element.dataset.bearerEndpoint;
	}

	getDXEAPIEndpoint(): string {
		if (!this._element.dataset.dxeEndpoint) {
			throw new Error(
				"'data-dxe-endpoint' value not provided on #CustomAddress input field."
			);
		}

		return this._element.dataset.dxeEndpoint;
	}
}

ComponentFactory.registerComponent("addressAutocomplete", AddressAutocomplete);
